import 'zone.js';  // Included with Angular CLI.

// required for amazon-cognito-identity-js
(window as any).global = window;

(window as any).process = {
    env: { DEBUG: undefined },
  };